export default __webpack_public_path__ + "static/lukaszp-10e4bb3e4c6435a0cc9f4d0466a0e172.jpg";